import axios from 'axios'
import '../Config'

const jwtToken = localStorage.getItem("authorization");

const INSTRUCTOR = 'v1'
const COURSE_API_URL = global.config.backend
const INSTRUCTOR_API_URL = `${COURSE_API_URL}/${INSTRUCTOR}`

class ClienteService {

    getByTelefone(telefone) {
        return axios.get(`${INSTRUCTOR_API_URL}/cliente/getbytelefone?telefone=${telefone}`);
    }

    getByCpf(cpf) {
        return axios.get(`${INSTRUCTOR_API_URL}/cliente/getbycpf?cpf=${cpf}`);
    }

    save(cliente) {
        return axios.post(`${INSTRUCTOR_API_URL}/cliente/save`, cliente);
    }
    
    create(cliente) {
        return axios.post(`${INSTRUCTOR_API_URL}/cliente/create`, cliente);
    }

}

export default new ClienteService()